import { CellProps } from 'react-table'
import { SetorActionsCell } from './SetorActionsCell'
import { SetorAsoList } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** LocalDateTime do backend → "dd/mm/aaaa hh:mm"; ausente vira o traço do StackedCell. */
const dataHora = (date?: string) => (date ? formatDateTime(date) : undefined)

export const SetorColumns = (t: TFunction): ReadonlyArray<TableColumn<SetorAsoList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<SetorAsoList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.nome ?? ''}`}
      />
    ),
  },
  sortableColumn<SetorAsoList>({
    id: 'nome',
    useQueryRequest,
    fields: [{ field: 'nome', label: 'Setor' }],
    Cell: ({ row }: CellProps<SetorAsoList>) => <StackedCell primary={row.original.nome} />,
  }),
  // Última edição em destaque; criação como linha de apoio.
  {
    Header: () => (
      <PlainHeader>
        {t('cols.data.edicao')} / {t('cols.data.criacao')}
      </PlainHeader>
    ),
    id: 'dataAlteracao',
    cellWidth: '188px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<SetorAsoList>) => (
      <StackedCell
        tabular
        primary={dataHora(row.original.dataAlteracao)}
        secondary={dataHora(row.original.dataInclusao)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<SetorAsoList>) => <SetorActionsCell setor={row.original} />,
  },
]
